import { AppUser, WallIncident, IncidentEscort } from 'incident-code-core'
import React from 'react'
import ReactPlayer from 'react-player'
import { Element } from 'react-scroll'
import styled from 'styled-components/macro'
import { UserIcon } from '../../../../components'
import { colors } from '../../../../constants'
import { SCROLL_CHILD_CLASS } from '../../../../constants/scroll'
import { useVideoService } from '../../../../services/video-service-hook'
import { Info } from './Info'
import { Title } from './Title'

import { openNewWindow } from '../../../../utils/browser-utils'

interface WallIncidentRestructured extends WallIncident {
  createdBy?: AppUser
  escortState?: IncidentEscort
}

interface IIncidentProps {
  incident: WallIncident
  id: string
  organization: string
  isPlaying: boolean
  escort?: string
  onClick?: CallableFunction
}

// Label should be dependant on incidient.type and incident.escortState.state
// Title will show Passive Escort for type passiveEscort, add label timer expired when
//

export const EscortCard = (props: IIncidentProps) => {
  const { incident, organization, id, isPlaying } = props
  const { escortState } = incident as WallIncidentRestructured
  const { state, playNext } = useVideoService(incident.videos)

  const url = state.video && state.video.url ? state.video.url : ''
  const createdBy = incident.createdBy
    ? incident.createdBy
    : { firstName: 'unknown', lastName: 'unknown', phone: 'unknown' }
  const incidentHasOneVideo = incident.videos.length === 1

  return (
    <NavContainer
      onClick={() =>{
        openNewWindow(`escort/${incident.id}`);
        props?.onClick();
      }}
      className={SCROLL_CHILD_CLASS}
    >
      {url ? (
        <StyledReactPlayer
          url={url}
          playing={isPlaying}
          loop={incidentHasOneVideo}
          onEnded={playNext}
          muted={true}
          width="100%"
          height="390px"
          style={{
            borderRadius: 6,
            overflow: 'hidden'
          }}
        />
      ) : (
        <DefaultImage>
          <UserIcon user={incident.createdBy as AppUser} />
        </DefaultImage>
      )}
      <IncidentBox name={incident.id.toString()}>
        <OverlayGradient />
        <Title
          index={id}
          organization={organization}
          createdAt={incident.createdAt}
          escort={incident.escort?.state}
          type={incident?.type}
        />
        <Info
          isOutOfZone={incident.organizationArea === null}
          admin={incident.escort?.lastAccess?.name}
          isUnresolved={incident.isNewIncident}
          isPanic={incident.isPanic}
          createdBy={createdBy as AppUser}
          address={incident.address}
          createdAt={incident.createdAt}
          type={incident.type}
          escortState={escortState}
        />
      </IncidentBox>
    </NavContainer>
  )
}

const NavContainer = styled.div`
  border-radius: 5px;
  position: relative;
  display: flex;
  flex-basis: 215px;
  height: 390px;
  flex-grow: 1;
  max-width: 280px;
  text-decoration: none;
  margin-bottom: 30px;
  margin-right: 30px;
  &:hover {
    cursor: pointer;
  }
`

const StyledReactPlayer = styled(ReactPlayer)`
  video {
    object-fit: cover;
  }
`

const DefaultImage = styled.div`
  width: 100%;
  height: 250px;
  display: flex;
  padding: 10px;
  justify-content: center;
  overflow: hidden;
`

const IncidentBox = styled(Element)`
  border-radius: 5px;
  display: flex;
  flex-flow: column nowrap;
  height: 390px;
  justify-content: space-between;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`

const OverlayGradient = styled.div`
  border-radius: 5px;
  position: absolute;
  z-index: 1;
  background: -moz-linear-gradient(
    top,
    ${colors.overlayGradientColors[0]} 0%,
    ${colors.overlayGradientColors[1]} 18%,
    ${colors.overlayGradientColors[2]} 50%,
    ${colors.overlayGradientColors[3]} 100%
  );
  background: -webkit-linear-gradient(
    top,
    ${colors.overlayGradientColors[0]} 0%,
    ${colors.overlayGradientColors[1]} 18%,
    ${colors.overlayGradientColors[2]} 50%,
    ${colors.overlayGradientColors[3]} 100%
  );
  background: linear-gradient(
    to bottom,
    ${colors.overlayGradientColors[0]} 0%,
    ${colors.overlayGradientColors[1]} 18%,
    ${colors.overlayGradientColors[2]} 50%,
    ${colors.overlayGradientColors[3]} 100%
  );
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`
